;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"460fa13b84c1ada843a3015118afe56db347e158"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { SHARED_SENTRY_CONFIG } from './sentry.shared.config';

Sentry.init({
  ...SHARED_SENTRY_CONFIG,
});
